<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="showState && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="showState && !$route.meta.keepAlive" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",
  data () {
    return {
      showState: true
    };
  },
  provide () {
    return {
      reload: this.reload
    };
  },
  methods: {
    reload () {
      this.showState = false;
      this.$nextTick(() => {
        this.showState = true;
      });
    },


  },
  watch: {
    '$route': {
      handler: async function (val) {
        try {


        } catch (error) {
          console.log("error", error);
        }
      },
      deep: true,
      immediate: true
    },
    local: {
      handler (val) {



      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapState({
      local: state => state.local,
    }),
  },
  mounted () {
    this.$store.dispatch('getUserDetailsByIdHandle')

  }
};
</script>

<style lang="scss">
@import './styles/reset.scss';

#app {
  width: 100%;
  height: 100%;
  & > div {
    width: 100%;
    height: 100%;
  }
}
.el-button--primary {
  background: #b07b00;
  border-color: #b07b00;
  &.is-plain {
    background: #f3efde;
    color: #b07b00;
  }
}
.el-button--primary:focus,
.el-button--primary:hover {
  background: #b07b00;
  border-color: #b07b00;
}
.el-button--default:focus,
.el-button--default:hover {
  color: #b07b00;
  border-color: #b07b00;
  background-color: #fff;
}
.el-button--text {
  color: #b07b00;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #b07b00;
}
.el-tabs__item.is-active {
  color: #b07b00;
}
.el-tabs__active-bar {
  background-color: #b07b00;
}
.el-tabs__item:hover {
  color: #b07b00;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus,
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #b07b00;
}

.el-select-dropdown__item.selected {
  color: #b07b00;
}
/deep/ .el-date-table td.current:not(.disabled) span {
  background-color: #b07b00;
}
.custom-popper {
  position: absolute !important;
  top: 50px !important;
  z-index: 999 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue